module.exports = __webpack_public_path__ + "img/金十数据@2x.67c6fd0a.png";